// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import AuditDealerHierarchyFacetAccordion from './dealer-hierarchy-facet';
import AuditList from './audit-list';
import DealerHierarchyFacet from '../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import ReportLinks from '../../../shared/components/report-links';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

class TcsmAudits extends Component {

    componentWillMount() {

        if (this.props.initialLoad) {

            this.props.actions.updateInitialLoad(false);

            if (this.props.territories.length < 1 || this.props.dealerHierarchyFacet.dealers.length < 1) {

                this.props.actions.readLeadAccounts(this.context.user.id);

            } else {

                this.props.actions.readAudits(this.props.dealerHierarchyFacet.dealers);
                this.props.actions.updateFilteredTerritories(this.props.territories);

            }

        } else {

            this.props.actions.readAudits(this.props.dealerHierarchyFacet.dealers);

        }

    }

    render() {

        return (
            <section className='tcsm-audits'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='tcsm-audits-aside'>
                    <AuditDealerHierarchyFacetAccordion/>
                    <ReportLinks
                        accordion={this.props.reportsAccordion}
                        onAccordionToggle={this.props::handleAccordionToggle}
                        parentRoute='tcsm'
                        routes={this.props.reportsRoutes}
                    />
                </aside>
                <main className='tcsm-audits-main'>
                    <AuditList/>
                </main>
            </section>
        );

    }

}

TcsmAudits.displayName = 'TcsmAudits';
TcsmAudits.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dealerHierarchyFacet: PropTypes.instanceOf(DealerHierarchyFacet).isRequired,
    initialLoad: PropTypes.bool.isRequired,
    reportsAccordion: PropTypes.instanceOf(Accordion).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired
};
TcsmAudits.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default TcsmAudits;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/index.js